import { BasicCommand } from "../../../common/services/cqs/BasicCommand";
import { CommandType } from "../../../common/services/cqs/CommandType";
import { IPrimaryKey } from "../../../common/services/cqs/IPrimaryKey";

export class RequestMergeAllDestineringsalternativCommand extends BasicCommand<RequestMergeAllDestineringsalternativCommand> {
    get primaryKey(): IPrimaryKey<RequestMergeAllDestineringsalternativCommand> {
        return {
            arbetsorderId: this.arbetsorderId
        };
    }
    arbetsorderId: number;
    checkAddIntressent: boolean;

    // eslint-disable-next-line sonarjs/public-static-readonly
    static $groupKey = "Arbetsorder";
    // eslint-disable-next-line sonarjs/public-static-readonly
    static $type = "RequestMergeAllDestineringsalternativCommand";
    constructor(init: (instance: RequestMergeAllDestineringsalternativCommand) => void) {
        super(RequestMergeAllDestineringsalternativCommand.$type, RequestMergeAllDestineringsalternativCommand.$groupKey, CommandType.Replace);
        init(this);
    }
}
